import React from 'react';
interface BonusCardProps {
  title: string;
  description: string;
  imageSrc: string;
  bonusNumber: number;
}
export function BonusCard({
  title,
  description,
  imageSrc,
  bonusNumber
}: BonusCardProps) {
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div onClick={scrollToPurchase} className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition-all duration-300 flex flex-col h-full cursor-pointer transform hover:scale-[1.02]" data-id="element-166">
      <div className="relative" data-id="element-167">
        <div className="aspect-square w-full overflow-hidden bg-gray-100 flex items-center justify-center p-4" data-id="element-168">
          <img src={imageSrc} alt={`Bono ${bonusNumber}: ${title}`} className="w-full h-full object-contain" data-id="element-169" />
        </div>
        <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg shadow-sm" data-id="element-170">
          GRATIS HOY
        </div>
        <div className="absolute top-0 left-0 bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-br-lg shadow-sm" data-id="element-171">
          BONO #{bonusNumber}
        </div>
      </div>

      <div className="p-5 flex flex-col flex-grow" data-id="element-172">
        <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight" data-id="element-173">
          {title}
        </h3>
        <p className="text-gray-600 text-sm flex-grow" data-id="element-174">{description}</p>
        <div className="mt-4 pt-4 border-t border-gray-100 text-center" data-id="element-175">
          <span className="text-green-600 font-bold text-sm uppercase tracking-wide" data-id="element-176">
            Incluido con tu compra
          </span>
        </div>
      </div>
    </div>;
}